/* Extracted from sections/collection-product-grid.liquid so it ships as a cached asset instead of inline JS. */
window.productGrid = window.productGrid || function() {
    return {
      activeFilters: [],
      allProducts: [],
      sortedProducts: [],
      
      init() {
        // Get all product cards
        this.allProducts = Array.from(document.querySelectorAll('#product-grid-container .product-card'));
        this.sortedProducts = [...this.allProducts];
        
        // Listen for filter changes
        window.addEventListener('filtersChanged', (e) => {
          this.activeFilters = e.detail.activeFilters;
          this.applyFilters();
        });
      },
      
      shouldShowProduct(element) {
        if (this.activeFilters.length === 0) {
          return true;
        }
        
        const onSale = element.dataset.onSale === 'true';
        const bestSeller = element.dataset.bestSeller === 'true';
        const plainMetal = element.dataset.plainMetal === 'true';
        
        // Filter out best_priced from matching logic (it's just for sorting)
        const contentFilters = this.activeFilters.filter(f => f !== 'best_priced');
        
        // If only best_priced is active, show all products
        if (contentFilters.length === 0) {
          return true;
        }
        
        // Check if product matches ALL active content filters (AND logic)
        let matches = true;
        for (const filter of contentFilters) {
          if (filter === 'on_sale' && !onSale) {
            matches = false;
            break;
          }
          if (filter === 'best_seller' && !bestSeller) {
            matches = false;
            break;
          }
          if (filter === 'plain_metal' && !plainMetal) {
            matches = false;
            break;
          }
        }
        
        return matches;
      },
      
      applyFilters() {
        // Sort by price if best_priced is active
        if (this.activeFilters.includes('best_priced')) {
          const visibleProducts = this.allProducts.filter(p => {
            return p.style.display !== 'none' && p.offsetParent !== null;
          });
          
          visibleProducts.sort((a, b) => {
            return parseInt(a.dataset.price) - parseInt(b.dataset.price);
          });
          
          // Reorder DOM elements
          const container = document.getElementById('product-grid-container');
          visibleProducts.forEach(product => {
            container.appendChild(product);
          });
        } else {
          // Reset to original order
          const container = document.getElementById('product-grid-container');
          this.allProducts.forEach(product => {
            container.appendChild(product);
          });
        }
        
        // Check if any products are visible
        this.$nextTick(() => {
          const visibleCount = Array.from(this.allProducts).filter(p => {
            return p.style.display !== 'none' && p.offsetParent !== null;
          }).length;
          
          // Show/hide "no products" message
          let noProductsMsg = document.getElementById('no-products-message');
          if (visibleCount === 0 && this.activeFilters.length > 0) {
            if (!noProductsMsg) {
              noProductsMsg = document.createElement('div');
              noProductsMsg.id = 'no-products-message';
              noProductsMsg.className = 'text-center py-12 col-span-full';
              noProductsMsg.innerHTML = '<p class="text-gray-500 text-lg">No products match the selected filters.</p>';
              const container = document.getElementById('product-grid-container');
              container.appendChild(noProductsMsg);
            }
            noProductsMsg.style.display = 'block';
          } else if (noProductsMsg) {
            noProductsMsg.style.display = 'none';
          }
        });
      }
    };
  };

(function () {
    function init(wrap) {
      if (!wrap || wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var btn = wrap.querySelector('[data-loadmore]');
      if (!btn) return;
      var label = wrap.querySelector('[data-loadmore-label]');
      var shown = wrap.querySelector('[data-shown]');
      var grid = document.getElementById('product-grid-container');
      var total = parseInt(wrap.dataset.totalPages, 10) || 1;
      var next = parseInt(wrap.dataset.nextPage, 10) || 2;

      btn.addEventListener('click', async function () {
        if (btn.disabled) return;
        btn.disabled = true;
        if (label) label.textContent = 'Loading…';
        try {
          // preserve any active Shopify filter/sort params
          var params = new URLSearchParams(window.location.search);
          params.set('page', next);
          params.set('section_id', wrap.dataset.sectionId);
          var res = await fetch(wrap.dataset.collectionUrl + '?' + params.toString());
          if (!res.ok) throw new Error(res.status);
          var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          var cards = doc.querySelectorAll('#product-grid-container .product-card');
          cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
          if (shown) shown.textContent = grid.querySelectorAll('.product-card').length;

          // Re-register the appended cards with the Alpine filter. Alpine 3 exposes the
          // reactive scope via Alpine.$data(el) — the v2 el.__x form is gone.
          try {
            var root = grid.closest('[x-data]');
            var data = (window.Alpine && root) ? window.Alpine.$data(root) : null;
            if (data && 'allProducts' in data) {
              data.allProducts = Array.from(grid.querySelectorAll('.product-card'));
              if (typeof data.applyFilters === 'function') data.applyFilters();
            }
          } catch (e) { /* filtering still works on the first page */ }
          window.dispatchEvent(new CustomEvent('productsAppended', { detail: { count: cards.length } }));

          next += 1;
          wrap.dataset.nextPage = next;
          if (next > total) { btn.remove(); }
          else if (label) { label.textContent = 'Load more'; }
        } catch (e) {
          if (label) label.textContent = 'Try again';
        } finally {
          btn.disabled = false;
        }
      });
    }
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-loadmore-wrap]').forEach(init);
    });
    if (document.readyState !== 'loading') {
      document.querySelectorAll('[data-loadmore-wrap]').forEach(init);
    }
  })();
